module.exports = __webpack_public_path__ + "static/media/Vec vectores_Tanque amarillo.753b194c.svg";